import { GET_EDIT_USER_PROFILE, GET_NOTIFICATION_URL, UPDATE_NOTIFICATION_URL, USER_DELETE_URL,GET_UPDATE_USER_PROFILE, DELETE_UPLOAD_DOCUMENT, GET_MEDICAL_HISTORY, UPDATE_MEDICAL_HISTORY, ADD_INJURY_HISTORY} from "../../config/adminUrlConfig";
import { ApiService } from "../../config/apiServices";
import {LOGIN_MOBILE_OTP, GET_USER_PROFILE, UPDATE_USER_PROFILE_DETAILS,UPDATE_USER_MOBILE,EMAIL_OTP_GENERATION_URL,UPDATE_USER_EMAIL,UPLOAD_DOCUMENT, CHECK_UPDATE_URL, GET_KIT_SIZES, GET_STATE_URL, GET_DISTRICT_URL, UPDATE_PROFILE_LIST_URL, UPDATE_USER_EMAIL_DIRECT, CHANGE_PASSWORD_URL, GET_USER_CATEGORY_MAIN, UPDATE_USER_TYPE_URL } from "../../config/user/userUrlConfig";
import { FileUploadService } from "../../config/apiServices";

export const getAllUserProfileList = (category_main_id,user_id) => {
    return ApiService.get(`${GET_USER_PROFILE}${category_main_id}/${user_id}`);
  };

  export const deletUserProfile = () => {
    return ApiService.delete(USER_DELETE_URL);
  };

// Submit combined profile updates
export const updateUserProfileDetails = (data) => {
  return ApiService.post(UPDATE_USER_PROFILE_DETAILS, data);
};

// ✅ Send OTP to new mobile number
export const sendMobileOtp = (mobile) => {
  return ApiService.post(LOGIN_MOBILE_OTP, { mobile });
};

export const updateUserMobileNumber = (mobile, otp) => {
  return ApiService.post(UPDATE_USER_MOBILE, {  mobile, otp  });
};


// ✅ Verify OTP for mobile number
// export const verifyMobileOtp = (mobile, otp) => {
//   return ApiService.post(OTP_VERIFICATION_MOBILE, { mobile, otp });
// };

// ✅ Resend OTP
// export const resendMobileOtp = (mobile) => {
//   return ApiService.post(RESET_LOGIN_MOBILE, { mobile });
// };

// export const updateUserMobileNumber = (user_id, mobile) => {
//   return ApiService.post(UPDATE_USER_MOBILE, { user_id, mobile });
// };


export const sendEmailOtp = (email) => {
  return ApiService.post(EMAIL_OTP_GENERATION_URL, { email });
}

export const updateUserEmail = (email, otp) => {
  return ApiService.post(UPDATE_USER_EMAIL, { email, otp });
}

// export const verifyEmailOtp = (email, otp) => {
//   return ApiService.post(EMAIL_OTP_VERIFICATION_URL, { email, otp });
// }


// Upload a single supportive document. Expects FormData with keys:
// - doc_name (string), file (File/Blob), user_id (string|number)
export const uploadUserDocument = (formData) => {
  return FileUploadService.post(UPLOAD_DOCUMENT, formData);
}

export const  notificationListApi = () => {
      return ApiService.get(GET_NOTIFICATION_URL);
};

export const  notificationUpdateApi = () => {
      return ApiService.post(UPDATE_NOTIFICATION_URL);
};



export const getAlleditProfileList = async(
  page=1,
  perPage=10,
  searchTerm="",
  statusFilter="",

)=>{
  return ApiService.get(`${GET_EDIT_USER_PROFILE}?number=${perPage}&page=${page}&search=${searchTerm}&status=${statusFilter}`)
}

export const getSingleUpdateProfileData=(id)=>{
return ApiService.get(`${GET_UPDATE_USER_PROFILE}/${id}`)
}


export const deleteUploadDocument=(id)=>{
  return ApiService.delete(`${DELETE_UPLOAD_DOCUMENT}/${id}`)
}


//Medical History

export const getmedicalhistory=()=>{
  return ApiService.get(`${GET_MEDICAL_HISTORY}`)
}

export const updatemedicalhistory=(formData)=>{
  return ApiService.post(UPDATE_MEDICAL_HISTORY,formData)
}


export const addInjuryhistory=(formData)=>{
  return ApiService.post(ADD_INJURY_HISTORY,formData)
}

export const checkUpdate = (data) => {
  // Using 'params' to send query parameters with GET request
  return ApiService.get(CHECK_UPDATE_URL, { params: data });
};

export const getKitSizes = () => {
  return ApiService.get(GET_KIT_SIZES);
};

export const getStateList = (id = 101) => {
  return ApiService.get(`${GET_STATE_URL}/${id}`);
};

export const getDistrictList = (id) => {
  return ApiService.get(`${GET_DISTRICT_URL}/${id}`);
};

export const getUpdateProfileList = (params) => {
  return ApiService.get(UPDATE_PROFILE_LIST_URL, { params });
};

export const updateUserEmailDirect = (email) => {
  return ApiService.post(UPDATE_USER_EMAIL_DIRECT, { email });
};

export const changeUserPassword = (payload) => {
  return ApiService.post(CHANGE_PASSWORD_URL, payload);
};

export const getUserCategoryMain = () => {
  return ApiService.get(GET_USER_CATEGORY_MAIN);
};

export const getCategoryTypesByMain = (mainId) => {
  return ApiService.get(`/registration/findUserCategoryTypeBYMainCategory/${mainId}`);
};

export const getCategorySubTypesByType = (typeId) => {
  return ApiService.get(`/registration/findUserCategorySubTypeByUserCategoryTypeId/${typeId}`);
};

export const updateUserType = (payload) => {
  return ApiService.post(UPDATE_USER_TYPE_URL, payload);
};

